export const ANESTHESIA_ASSISTANT_APP_ID = '674997d8c4aaadc4054b3372';

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export const SUBSCRIPTION_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'monthly', label: 'Monthly' },
  { value: 'yearly', label: 'Yearly' },
  { value: 'license', label: 'License' },
  { value: 'not_subscribed', label: 'No subscription' },
];

export const MONTH_RANGE_OPTIONS = [
  { value: 'thisMonth', label: 'This Month' },
  { value: 'lastMonth', label: 'Last Month' },
  { value: 'last3Months', label: 'Last 3 Months' },
  { value: 'last6Months', label: 'Last 6 Months' },
  { value: 'custom', label: 'Custom' },
];

export const ROLE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'user', label: 'User' },
  { value: 'assistant', label: 'Assistant' },
];

export const TRUE_FALSE_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
];

export const formatMonth = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
  }
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
};

export const computeMonthPreset = (range) => {
  const now = new Date();
  let startMonth;
  let endMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  let monthRange = range;

  switch (range) {
    case 'thisMonth':
      startMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    case 'lastMonth':
      startMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      break;
    case 'last3Months':
      startMonth = new Date(now.getFullYear(), now.getMonth() - 2, 1);
      break;
    case 'last6Months':
      startMonth = new Date(now.getFullYear(), now.getMonth() - 5, 1);
      break;
    default:
      monthRange = 'last3Months';
      startMonth = new Date(now.getFullYear(), now.getMonth() - 2, 1);
  }

  return { monthRange, startMonth, endMonth };
};

export const getApiBaseUrl = () =>
  (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export const downloadCsv = (rows, filename) => {
  if (!rows.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`;
  const lines = [
    headers.join(','),
    ...rows.map((row) => headers.map((key) => escape(row[key])).join(',')),
  ];
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
};

export const formatDateTime = (value) => {
  if (!value) return '-';
  const normalized = typeof value === 'string' ? value.replace(/(\.\d{3})\d+(Z)$/i, '$1$2') : value;
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) return '-';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

export const exportTimestamp = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

export const formatMonthLabel = (monthKey) => {
  if (!monthKey) return '-';
  const [year, month] = monthKey.split('-');
  const date = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(date.getTime())) return monthKey;
  return date.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
};
